import { CourseRouteTypeEnum } from "@ryde/shared";

export const getCourseInfoTranslationKey = (
  courseType: CourseRouteTypeEnum,
): string => {
  switch (courseType) {
    case CourseRouteTypeEnum.Flex:
      return "selectListLabel.FlexKeepInfo";
    case CourseRouteTypeEnum.SplitConnection:
      return "selectListLabel.SplitConnectionInfo";
    case CourseRouteTypeEnum.JoinConnection:
      return "selectListLabel.JoinConnectionInfo";
    case CourseRouteTypeEnum.Combined:
      return "selectListLabel.CombinedConnectionInfo";
    default:
      return "selectListLabel.ShuttleInfo";
  }
};
